import(/* webpackMode: "eager" */ "/opt/build/repo/app/ventilation-installation/page.tsx");
